export default {
    primitive: {
    red: {
        50: "#FFFAFA",
        100: "#FEE6E6",
        200: "#FECACA",
        300: "#FC9C9C",
        400: "#F76363",
        500: "#EF3E3E",
        600: "#DE3030",
        700: "#CC1F1F",
        800: "#991B1B",
        900: "#781B1B",
        950: "#6B0F0F"
    },
    sky: {
        50: "#f0f9ff",
        100: "#e5f0ff",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e",
        950: "#082f49"
    },
    blue: {
        50: "#F5F9FF",
        100: "#E0EDFF",
        200: "#C7DEFF",
        300: "#8FBDFF",
        400: "#6EA9FC",
        500: "#5392EF",
        600: "#2C73D9",
        700: "#275CA5",
        800: "#104DA2",
        900: "#083F8C",
        950: "#002F70"
    },
    cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63",
        950: "#083344"
    },
    gray: {
        50: "#F9FAFB",
        100: "#F0F3F5",
        200: "#E0E6EB",
        300: "#C2CED6",
        400: "#ADB8C0",
        500: "#8A959D",
        600: "#6A7781",
        700: "#52697A",
        800: "#3D4F5C",
        900: "#2C373F",
        950: "#111518"
    },
    lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314",
        950: "#1a2e05"
    },
    pink: {
        50: "#FFF5F9",
        100: "#FFEFF6",
        200: "#FBD0E3",
        300: "#F8A0C7",
        400: "#F15C9E",
        500: "#EE3688",
        600: "#E1126E",
        700: "#D90C5B",
        800: "#BD0A50",
        900: "#9D0741",
        950: "#780230"
    },
    rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337",
        950: "#4c0519"
    },
    teal: {
        50: "#F8FCFC",
        100: "#D9F1F2",
        200: "#C6EBEB",
        300: "#A0DDDE",
        400: "#66C8CA",
        500: "#45A8AA",
        600: "#3B9EA0",
        700: "#1B8385",
        800: "#126264",
        900: "#094D4E",
        950: "#073F41"
    },
    zinc: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b",
        950: "#09090b"
    },
    amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f",
        950: "#451a03"
    },
    green: {
        50: "#F3FFEF",
        100: "#D9FFCC",
        200: "#BAF5A8",
        300: "#78EF53",
        400: "#47CA20",
        500: "#47A72A",
        600: "#398623",
        700: "#347114",
        800: "#195B06",
        900: "#174A08",
        950: "#0D3800"
    },
    slate: {
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a",
        950: "#020617"
    },
    stone: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917",
        950: "#0c0a09"
    },
    indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81",
        950: "#1e1b4b"
    },
    orange: {
        50: "#FEF8F4",
        100: "#FDE2CE",
        200: "#FAC59E",
        300: "#F8A86D",
        400: "#F47A20",
        500: "#EF6D0C",
        600: "#E05812",
        700: "#D14900",
        800: "#AA3D02",
        900: "#8F3200",
        950: "#612200"
    },
    purple: {
        50: "#FEF5FF",
        100: "#FCE5FF",
        200: "#F5C9FD",
        300: "#E895F8",
        400: "#D85BF1",
        500: "#BF2CDD",
        600: "#A928C3",
        700: "#9A05B8",
        800: "#8900A3",
        900: "#610075",
        950: "#540066"
    },
    violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95",
        950: "#2e1065"
    },
    yellow: {
        50: "#FFFBF0",
        100: "#FFF5DB",
        200: "#FFF0CC",
        300: "#FFE199",
        400: "#FED267",
        500: "#FEC231",
        600: "#F6AE23",
        700: "#EF9B16",
        800: "#CD810A",
        900: "#A76702",
        950: "#8D5701"
    },
    emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b",
        950: "#022c22"
    },
    fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75",
        950: "#4a044e"
    },
    neutral: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717",
        950: "#0a0a0a"
    },
    borderRadius: {
        lg: "12px",
        md: "8px",
        sm: "4px",
        xl: "16px",
        xs: "2px",
        none: "0"
    }
},
    semantic: {
    list: {
        gap: "0.25rem 0.25rem",
        header: {
            padding: "0.5rem 0.75rem 0.25rem 0.75rem"
        },
        option: {
            padding: "0.5rem 0.75rem",
            borderRadius: "{border.radius.sm}"
        },
        padding: "0.25rem 0.25rem",
        optionGroup: {
            padding: "0.5rem 0.75rem",
            fontWeight: "{font.weight.semibold}"
        }
    },
    mask: {
        transitionDuration: "0.2s"
    },
    content: {
        borderRadius: "{border.radius.md}"
    },
    overlay: {
        modal: {
            shadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1),0 8px 10px -6px rgba(0, 0, 0, 0.1)",
            padding: "1.25rem",
            borderRadius: "{border.radius.lg}"
        },
        select: {
            shadow: "0 1px 2px 0 rgba(18, 18, 23, 0.05)",
            borderRadius: "{border.radius.md}"
        },
        popover: {
            shadow: "0 1px 2px 0 rgba(18, 18, 23, 0.05)",
            padding: "0.75rem",
            borderRadius: "{border.radius.md}"
        },
        navigation: {
            shadow: "0 1px 2px 0 rgba(18, 18, 23, 0.05)"
        }
    },
    primary: {
        50: "{brand.50}",
        100: "{brand.100}",
        200: "{brand.200}",
        300: "{brand.300}",
        400: "{brand.400}",
        500: "{brand.500}",
        600: "{brand.600}",
        700: "{brand.700}",
        800: "{brand.800}",
        900: "{brand.900}",
        950: "{brand.950}"
    },
    iconSize: "1rem",
    focusRing: {
        color: "{primary.600}",
        style: "solid",
        width: "1px",
        offset: "2px",
        shadow: "0 0 0 0 rgba(0, 0, 0, 0)"
    },
    formField: {
        lg: {
            fontSize: "{font.size.large}",
            paddingX: "0.875rem",
            paddingY: "0.625rem"
        },
        sm: {
            fontSize: "{font.size.medium}",
            paddingX: "0.5rem",
            paddingY: "0.375rem"
        },
        paddingX: "0.5rem",
        paddingY: "8px",
        focusRing: {
            color: "transparent",
            style: "none",
            width: "0",
            offset: "0",
            shadow: "0 0 0 0 rgba(0, 0, 0, 0)"
        },
        borderRadius: "{border.radius.sm}",
        transitionDuration: "{transition.duration}"
    },
    navigation: {
        item: {
            gap: "0.5rem",
            padding: "0.5rem 0.75rem",
            borderRadius: "{border.radius.sm}"
        },
        list: {
            gap: "2px",
            padding: "0.25rem 0.25rem"
        },
        submenuIcon: {
            size: "0.875rem"
        },
        submenuLabel: {
            padding: "0.5rem 0.75rem",
            fontWeight: "{font.weight.semibold}"
        }
    },
    colorScheme: {
        dark: {
            list: {
                option: {
                    icon: {
                        color: "{surface.500}",
                        focusColor: "{surface.400}"
                    },
                    color: "{text.color}",
                    focusColor: "{text.hover.color}",
                    selectedColor: "{highlight.color}",
                    focusBackground: "{surface.800}",
                    selectedBackground: "{highlight.background}",
                    selectedFocusColor: "{highlight.focus.color}",
                    selectedFocusBackground: "{highlight.focus.background}"
                },
                optionGroup: {
                    color: "{text.muted.color}",
                    background: "transparent"
                }
            },
            mask: {
                color: "{surface.200}",
                background: "rgba(0,0,0,0.6)"
            },
            text: {
                color: "{surface.0}",
                hoverColor: "{surface.0}",
                mutedColor: "{surface.400}",
                hoverMutedColor: "{surface.300}"
            },
            content: {
                color: "{text.color}",
                background: "{surface.900}",
                hoverColor: "{text.hover.color}",
                borderColor: "{surface.700}",
                hoverBackground: "{surface.800}"
            },
            overlay: {
                modal: {
                    color: "{text.color}",
                    background: "{surface.900}",
                    borderColor: "{surface.700}"
                },
                select: {
                    color: "{text.color}",
                    background: "{surface.900}",
                    borderColor: "{surface.700}"
                },
                popover: {
                    color: "{text.color}",
                    background: "{surface.900}",
                    borderColor: "{surface.700}"
                }
            },
            primary: {
                color: "{primary.400}",
                hoverColor: "{primary.300}",
                activeColor: "{primary.200}",
                contrastColor: "{surface.900}"
            },
            surface: {
                0: "{white}",
                50: "{gray.50}",
                100: "{gray.100}",
                200: "{gray.200}",
                300: "{gray.300}",
                400: "{gray.400}",
                500: "{gray.500}",
                600: "{gray.600}",
                700: "{gray.700}",
                800: "{gray.800}",
                900: "{gray.900}",
                950: "{gray.950}"
            },
            formField: {
                color: "{surface.0}",
                shadow: "0 1px 2px 0 rgba(18, 18, 23, 0.05)",
                iconColor: "{surface.400}",
                background: "{surface.950}",
                borderColor: "{surface.600}",
                disabledColor: "{surface.400}",
                floatLabelColor: "{surface.400}",
                filledBackground: "{surface.800}",
                focusBorderColor: "{primary.color}",
                hoverBorderColor: "{surface.500}",
                placeholderColor: "{surface.400}",
                disabledBackground: "{surface.700}",
                invalidBorderColor: "{red.300}",
                floatLabelFocusColor: "{surface.400}",
                filledFocusBackground: "{surface.800}",
                filledHoverBackground: "{surface.800}",
                floatLabelActiveColor: "{surface.400}",
                floatLabelInvalidColor: "{form.field.invalid.placeholder.color}",
                invalidPlaceholderColor: "{red.400}"
            },
            highlight: {
                color: "rgba(255,255,255,.87)",
                background: "color-mix(in srgb, {primary.400}, transparent 84%)",
                focusColor: "rgba(255,255,255,.87)",
                focusBackground: "color-mix(in srgb, {primary.400}, transparent 76%)"
            },
            navigation: {
                item: {
                    icon: {
                        color: "{surface.500}",
                        focusColor: "{surface.400}",
                        activeColor: "{surface.400}"
                    },
                    color: "{text.color}",
                    focusColor: "{text.hover.color}",
                    activeColor: "{text.hover.color}",
                    focusBackground: "{surface.800}",
                    activeBackground: "{surface.800}"
                },
                submenuIcon: {
                    color: "{surface.500}",
                    focusColor: "{surface.400}",
                    activeColor: "{surface.400}"
                },
                submenuLabel: {
                    color: "{text.muted.color}",
                    background: "transparent"
                }
            }
        },
        light: {
            list: {
                option: {
                    icon: {
                        color: "{surface.400}",
                        focusColor: "{surface.500}"
                    },
                    color: "{text.color}",
                    focusColor: "{text.hover.color}",
                    selectedColor: "{highlight.color}",
                    focusBackground: "{surface.100}",
                    selectedBackground: "{highlight.background}",
                    selectedFocusColor: "{highlight.focus.color}",
                    selectedFocusBackground: "{highlight.focus.background}"
                },
                optionGroup: {
                    color: "{text.muted.color}",
                    background: "transparent"
                }
            },
            mask: {
                color: "{surface.200}",
                background: "rgba(0,0,0,0.4)"
            },
            text: {
                color: "{surface.800}",
                hoverColor: "{surface.800}",
                mutedColor: "{surface.600}",
                hoverMutedColor: "{surface.600}"
            },
            content: {
                color: "{text.color}",
                background: "{surface.0}",
                hoverColor: "{text.hover.color}",
                borderColor: "{surface.200}",
                hoverBackground: "{surface.100}"
            },
            overlay: {
                modal: {
                    color: "{text.color}",
                    background: "{surface.0}",
                    borderColor: "{surface.200}"
                },
                select: {
                    color: "{text.color}",
                    background: "{surface.0}",
                    borderColor: "{surface.200}"
                },
                popover: {
                    color: "{text.color}",
                    background: "{surface.0}",
                    borderColor: "{surface.200}"
                }
            },
            primary: {
                color: "{primary.800}",
                hoverColor: "{primary.900}",
                activeColor: "{primary.950}",
                contrastColor: "{white}"
            },
            surface: {
                0: "{white}",
                50: "{gray.50}",
                100: "{gray.100}",
                200: "{gray.200}",
                300: "{gray.300}",
                400: "{gray.400}",
                500: "{gray.500}",
                600: "{gray.600}",
                700: "{gray.700}",
                800: "{gray.800}",
                900: "{gray.900}",
                950: "{gray.950}"
            },
            formField: {
                color: "{surface.700}",
                shadow: "0 1px 2px 0 rgba(18, 18, 23, 0.05)",
                iconColor: "{surface.400}",
                background: "{surface.0}",
                borderColor: "{surface.400}",
                disabledColor: "{surface.600}",
                floatLabelColor: "{text.muted.color}",
                filledBackground: "{surface.50}",
                focusBorderColor: "{primary.color}",
                hoverBorderColor: "{surface.500}",
                placeholderColor: "{surface.500}",
                disabledBackground: "{surface.100}",
                invalidBorderColor: "{red.600}",
                floatLabelFocusColor: "{text.muted.color}",
                filledFocusBackground: "{surface.50}",
                filledHoverBackground: "{surface.50}",
                floatLabelActiveColor: "{text.muted.color}",
                floatLabelInvalidColor: "{form.field.invalid.placeholder.color}",
                invalidPlaceholderColor: "{red.600}"
            },
            highlight: {
                color: "{primary.800}",
                background: "{primary.50}",
                focusColor: "{primary.800}",
                focusBackground: "{primary.100}"
            },
            navigation: {
                item: {
                    icon: {
                        color: "{surface.400}",
                        focusColor: "{surface.500}",
                        activeColor: "{surface.500}"
                    },
                    color: "{text.color}",
                    focusColor: "{text.hover.color}",
                    activeColor: "{text.hover.color}",
                    focusBackground: "{surface.100}",
                    activeBackground: "{surface.100}"
                },
                submenuIcon: {
                    color: "{surface.400}",
                    focusColor: "{surface.500}",
                    activeColor: "{surface.500}"
                },
                submenuLabel: {
                    color: "{primary.color}",
                    background: "transparent"
                }
            }
        }
    },
    anchorGutter: "2px",
    disabledOpacity: "0.6",
    transitionDuration: "0.2s"
}
    }